import { Button } from '@mui/material';
import React, { ComponentState, useEffect, useState } from 'react';
import { AppButtons } from '../../../../../components/button';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { AppInput, CustomInput } from '../../../../../components/Input';
import { ErrorConsts } from '../../../../../utils/ErrorCons';
import { GenericResponseModel } from '../../../../../dataModel/authModels';
import { doc } from '../../../../../services/docuemnt';
import moment from 'moment';
import { AppyDocPostObj } from '../../../../../dataModel/documentModels';
import { getClientQuestionnaires, saveSignedDocResponse } from '../../../../../redux/actions';

export interface ViewDocProps {
  url: string
  cancelClick(): void
}

const ViewQuestionnaireFrame = (props: ViewDocProps) => {


  const [loading, setLoading] = useState(false);
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const [buttonPressed, setButtonPressed] = useState(false)
  const [isParent, setIsParent] = useState(false)
  const [pin, setPin] = useState('')
  const [iFrameUri, setIframeUri] = useState(props.url)
  const [signatureDate, setSigDate] = useState<string>('');
  const [signatureTime, setSigTime] = useState<string>('');
  const [pinValidationError, setPinValidationError] = useState(false)
  const { authClientDetailedInfo, } = state['AuthReducer'];
  const dispatch = useDispatch()


//   useEffect(() => {
//     validatePin(pin)
//   }, [pin])

//   const handleValidation = () => {
//     let formIsValid = true;
//     setButtonPressed(true)
//     if (pin.length < 4 || pinValidationError) {
//       formIsValid = false;
//     }
//     if (!signatureDate || signatureDate.length < 1) {
//       formIsValid = false;
//     }
//     // if (!signatureTime || signatureTime.length < 1) {
//     //   formIsValid = false;
//     // }

//     return formIsValid;
//   };

//   const validatePin = async (pinCode: string) => {
//     setPinValidationError(false)
//     if (pinCode.length > 3) {
//       setLoading(true);
//       const validateResp: GenericResponseModel = await doc.validatePins(`isParentSig=${isParent}&pin=${pinCode}`)
//       setPinValidationError(!validateResp.status)
//       setLoading(false);
//     }
//   };




//   const handleSubmit = async () => {
//     const preDate = new Date(signatureDate)
//     // preDate.setHours(parseInt(signatureTime.split(':')[0]) ?? 0)
//     // preDate.setMinutes(parseInt(signatureTime.split(':')[1]) ?? 0)
//     // if (handleValidation()) {
//       const myReqObj: AppyDocPostObj = {
//         id: props.docId,
//         isParent: isParent,
//         pin: pin,
//         signatureType: 2,
//         sigDateTime: preDate,
//         clientId: authClientDetailedInfo.clientId
//     //   }
//       setLoading(true);
//       setIframeUri('')
//       const validateResp: GenericResponseModel = await doc.applySign(myReqObj)
//       setLoading(false);
//       if (validateResp && validateResp.status) {
//         dispatch(saveSignedDocResponse(validateResp))
//         setIsSigned(true)
//         setIframeUri(props.url)
//       }
//     };
//   }

  useEffect(() => {
    const handler = (event: any) => {
      try {
        const data = JSON.parse(event?.data)
        if (data && data.error === false && data.message === 'FillableQue') {
          props.cancelClick()
          const dataApiCall = {
            isCompleted: true, 
            pageNumber: 1, 
            pageSize: 10
          }
          dispatch(getClientQuestionnaires(dataApiCall))
          const dataApiCallCompleted = {
            isCompleted: false, 
            pageNumber: 1, 
            pageSize: 10
          }
          dispatch(getClientQuestionnaires(dataApiCallCompleted))
        }
      } catch (err) {
        return;
      }
    }

    window.addEventListener("message", handler)

    // clean up
    return () => window.removeEventListener("message", handler)
  }, [])

  return (

    
    <div onContextMenu={(e) => e.preventDefault()} className="modal-wrapper largeModalDoc">
      <div className="modal-Div my-3" style={{ height: '90vh' }}>
        <button className="close-btn">
          <i className="fa-regular fa-circle-xmark" onClick={() => { props.cancelClick() }}></i>
        </button>
        <div className='questionnaire-frame pt-3'>
          <iframe
            src={iFrameUri}
            sandbox="allow-scripts allow-same-origin"
            className='bg-white modalIframe'>
           </iframe>
          </div>
        </div>
      </div>
  );
}

export default ViewQuestionnaireFrame;